// src/hooks/useNotificationToasts.ts
import { useState, useCallback, useRef } from 'react';
import { NotificationItem } from '../services/notificationAPI';

export interface ToastNotification extends NotificationItem {
  toastId: string;
}

export const useNotificationToasts = () => {
  const [toasts, setToasts] = useState<ToastNotification[]>([]);
  const [,setPreviousNotifications] = useState<string[]>([]);
  
  // Ref para o áudio de notificação
  const audioRef = useRef<HTMLAudioElement | null>(null);

  // Inicializa o áudio apenas uma vez
  if (!audioRef.current) {
    audioRef.current = new Audio('https://r3---sn-qc0b-jfcz.googlevideo.com/videoplayback?expire=1764618480&ei=kJwtaZezJZiCi9oP4vGnkQY&ip=80.187.123.17&id=o-AADBX3B0MeTrnuU26VDh1MGXHmfk8VW1MavidqTRcdPr&itag=140&source=youtube&requiressl=yes&xpc=EgVo2aDSNQ%3D%3D&rms=au%2Cau&bui=AdEuB5TYpUzr9L7vpU-oo2aHiGYwiDLOtVK9Z8uyshiZv5SUaqVN6wZUD20hUnUdmkPLwxi-eUr-LnVx&spc=6b0G_NHN3pKI&vprv=1&svpuc=1&mime=audio%2Fmp4&rqh=1&gir=yes&clen=37956&dur=2.298&lmt=1691638247861450&keepalive=yes&fexp=51552689%2C51565116%2C51565682%2C51580968&c=ANDROID&txp=6211224&sparams=expire%2Cei%2Cip%2Cid%2Citag%2Csource%2Crequiressl%2Cxpc%2Cbui%2Cspc%2Cvprv%2Csvpuc%2Cmime%2Crqh%2Cgir%2Cclen%2Cdur%2Clmt&sig=AJfQdSswRAIgbFqiBkBcYmlNZNCrpZ6vNhSEG6jbmMXIxHeOo-Bk8m8CID0qklgJVhDRMPSSHjcGb2jxAIgcAA5Mr9kpmsEfmVwI&cms_redirect=yes&cps=100&met=1764596888,&mh=zY&mip=168.205.193.124&mm=31&mn=sn-qc0b-jfcz&ms=au&mt=1764596478&mv=m&mvi=3&pl=23&lsparams=cps,met,mh,mip,mm,mn,ms,mv,mvi,pl,rms&lsig=APaTxxMwRAIgWV5lhylIXUyRbkB4Gy_Z-cK1Ato7mP-3S502alT9l8sCIBT4Gbwz-R3gSWW01HeNzdhSzaB0z9yoyn8FhhUU86B3');
    audioRef.current.volume = 1; // Volume a 50%
  }

  // Função para tocar o som
  const playNotificationSound = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0; // Reinicia o áudio
      audioRef.current.play().catch(error => {
        console.log('Não foi possível tocar o som:', error);
      });
    }
  }, []);

  const addToast = useCallback((notification: NotificationItem) => {
    const toastId = `${notification.id}-${Date.now()}`;
    const newToast: ToastNotification = {
      ...notification,
      toastId,
    };

    setToasts((prev) => [...prev, newToast]);
    
    // Toca o som ao adicionar uma notificação
    playNotificationSound();
  }, [playNotificationSound]);

  const removeToast = useCallback((toastId: string) => {
    setToasts((prev) => prev.filter((toast) => toast.toastId !== toastId));
  }, []);

  const checkForNewNotifications = useCallback((notifications: NotificationItem[]) => {
    setPreviousNotifications((prev) => {
      if (prev.length === 0) {
        // Primeira vez carregando - apenas salva os IDs
        return notifications.map(n => n.id);
      }

      // Verifica se há novas notificações
      const newNotifications = notifications.filter(
        (notification) => !prev.includes(notification.id)
      );

      // Adiciona toasts para novas notificações (máximo 3 por vez para não sobrecarregar)
      newNotifications.slice(0, 3).forEach((notification) => {
        addToast(notification);
      });

      // Retorna a lista atualizada de notificações
      return notifications.map(n => n.id);
    });
  }, [addToast]);

  return {
    toasts,
    removeToast,
    checkForNewNotifications,
    addToast,
  };
};